<mwe-modal [model]="popupModel()">
  <div class="row">
    <div class="col-md-7 col-12">
      <h3 class="bigger text-start" data-test="banner-popup-title">{{ popupData().title }}</h3>
      <div [innerHTML]="popupData().content" data-test="banner-popup-content"></div>
    </div>
    @if (imageUrl()) {
      <div class="col-md-5 col-12">
        <img [src]="imageUrl()" class="img-fluid" [alt]="popupData().image" />
      </div>
    }
  </div>

  <ng-container slot="footer">
    <div class="p-4 bg-gray--200">
      <div class="row g-3 justify-content-between">
        <div class="col-md-auto">
          <mwe-button
            labelKey="cookie-banner.buttons.accept"
            [hasFullWidth]="true"
            [showHoverEffect]="true"
            [labelKey]="popupData().acceptButton.text"
            (clicked)="submit()"
            buttonId="banner-popup-accept-button"
          />
        </div>
        <div class="col-md-auto">
          <mwe-button
            category="secondary"
            [hasFullWidth]="true"
            [labelKey]="popupData().rejectButton"
            (clicked)="cancel()"
            buttonId="banner-popup-reject-button"
          />
        </div>
      </div>
    </div>
  </ng-container>
</mwe-modal>
